import React from "react";
import { Alert } from "react-bootstrap";

const FormAlert = ({ alertTextList }) => {
  return (
    <Alert variant="danger">
      {alertTextList.map((text, index) => (
        <li key={index}>{text}</li>
      ))}
    </Alert>
  );
};

export default FormAlert;
